import styled from 'styled-components';
import { useMessageModalStore, useIsDifferenceStore } from './MessagePromptStore';
import { AlertModal } from 'components/Modal/AlertModal';

import { Stack } from 'components/Stack';
import { Text } from 'components/Typography';
import { Button } from 'components/Button';

const MessagePromptModal = () => {
  const { isModalOpen, navigate, closeModal, clearNavigate } = useMessageModalStore();
  const { isDifference, setIsDifference } = useIsDifferenceStore();

  const onCancelDraft = () => {
    if (navigate) {
      navigate(); // 저장된 함수 실행
      clearNavigate(); // 함수 초기화
      setIsDifference(false); // 작성 중인 글이 없음
    }
    closeModal(); // 모달 닫기
  };

  const onKeepingWriting = () => {
    return closeModal();
  };

  return (
    <AlertModal
      type="WARNING"
      isOpen={isModalOpen}
      messages={
        <Stack sx={{ gap: '8px' }}>
          <Text styleName="body2" color="RG02">
            작성을 취소할까요?
          </Text>
          <Text styleName="body2" color="RG02">
            작성 중이던 내용은 저장되지 않습니다.
          </Text>
        </Stack>
      }
      buttonGroup={
        <ModalButtonDiv>
          <Button variant="tertiary" h={40} sx={{ width: '100%', marginTop: '40px' }} onClick={onKeepingWriting}>
            <Text styleName="body1" color="RG03">
              계속 작성
            </Text>
          </Button>
          <Button variant="primary" h={40} sx={{ width: '100%', marginTop: '40px' }} onClick={onCancelDraft}>
            <Text styleName="body1" color="RG00">
              작성 취소
            </Text>
          </Button>
        </ModalButtonDiv>
      }
    />
  );
};

export default MessagePromptModal;

const ModalButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;
